import {ANY_REACTION_COMPONENT_ROLE_LABEL} from 'chemistry/ChemistryConstants';
import {
  ChemistryReactionRole,
  CHEMISTRY_REACTION_ROLE_TO_DISPLAY_NAME,
  CHEMISTRY_REACTION_ROLE_TO_SORT_ORDER,
} from 'notebook/integrations/chemistry/ChemistryStructuredTableConstants';
import {isChemicalStructureFilter, SearchParams} from 'search/SearchConstants';

/** Roles shown in chem search UI; matches stoichiometry table. */
export const REACTION_COMPONENT_ROLE_UI_ORDER: Array<ChemistryReactionRole> = Object.values(
  ChemistryReactionRole
).sort((a, b) => CHEMISTRY_REACTION_ROLE_TO_SORT_ORDER[a] - CHEMISTRY_REACTION_ROLE_TO_SORT_ORDER[b]);

const UI_REACTION_COMPONENT_ROLES = new Set<string>(Object.values(ChemistryReactionRole));

export function parseChemistryReactionRole(role: string | null | undefined): ChemistryReactionRole | null {
  if (role != null && UI_REACTION_COMPONENT_ROLES.has(role)) {
    return role as ChemistryReactionRole;
  }
  return null;
}

export function getDefaultReactionComponentRole(searchParams: SearchParams): ChemistryReactionRole | null {
  for (const filter of searchParams.filters) {
    if (isChemicalStructureFilter(filter) && filter.reactionComponentRole != null) {
      return parseChemistryReactionRole(filter.reactionComponentRole);
    }
  }
  return null;
}

export function getReactionComponentRoleOptionLabel(role: ChemistryReactionRole | null): string {
  if (role == null) {
    return ANY_REACTION_COMPONENT_ROLE_LABEL;
  }
  return CHEMISTRY_REACTION_ROLE_TO_DISPLAY_NAME[role];
}
